// client/src/components/shared/BrandLogo.js
// Logos Ecobill réutilisables (sidebar sombre, pages claires, écrans de chargement).
import React from 'react';
import { Link } from 'react-router-dom';

// Logo horizontal (texte crème) — pour fonds sombres
export const LOGO_WIDE_LIGHT =
  'https://firebasestorage.googleapis.com/v0/b/ecobill-pay.firebasestorage.app/o/Administratif%2Flogo_allonge.png?alt=media&token=d253d70e-93fe-4de4-8417-132abb4e5f26';
// Pictogramme noix de coco — servi localement (disponible hors-ligne, pas de requête Storage)
export const LOGO_ICON = '/logo_ecobill.png';

/** En-tête de la sidebar desktop (masqué en mobile par Navbar.css). */
export function SidebarBrand({ label }) {
  return (
    <div className="sidebar-brand">
      <img src={LOGO_WIDE_LIGHT} alt="Ecobill" className="sidebar-brand__logo" />
      {label ? <span className="sidebar-brand__label">{label}</span> : null}
    </div>
  );
}

/** Pictogramme + nom, pour fonds clairs. */
export function BrandMark({ to = '/', size = 40 }) {
  const content = (
    <>
      <img src={LOGO_ICON} alt="" width={size} height={size} style={{ objectFit: 'contain' }} />
      <span className="eb-brandmark__name" style={{ fontSize: Math.round(size * 0.68) }}>Ecobill</span>
    </>
  );
  if (!to) return <span className="eb-brandmark">{content}</span>;
  return <Link to={to} className="eb-brandmark" aria-label="Ecobill — accueil">{content}</Link>;
}
